import type {ReactNode} from 'react';

export type RatingRadioGroupLegendProps = {
  children?: ReactNode;
};

export function RatingRadioGroupLegend({children}: RatingRadioGroupLegendProps) {
  if (!children) return null;

  return <legend className="mb-2 text-base">{children}</legend>;
}
